export default __webpack_public_path__ + "static/Framework2-1de5faaf979ea29e9fa5cc936f699475.svg";